import { getClientStorage } from './clientStorage';
import { translateLangCodeToModuleName } from './translateLangCodeToModuleName';

export const getActualLang = () =>
  translateLangCodeToModuleName(getClientStorage("language") || "en");
